import React from 'react';
import { titleWithoutUnderscore } from "../../helpers/utility";
import { ProcessedMessageWithTags } from "../../helpers/utility";
import DocImg from "../../components/docImg";
import SelectedMessageSection from "./selectedMessageSectionToShow"
import ConvertStringToHtml from '../../components/ConvertStringToHtml';


const ReturnMessageToReply = ({msg}) => {

    let messageText;
    const media = Array.isArray(msg?.message?.media) ? msg.message.media : [];
    if (!msg) {
        return null;
    }
    else{
        if(msg?.event_type == 'change_status'){
            messageText = msg?.message?.data?.text || '';
        }else{
            messageText = msg?.message?.text || '';
        }


        return (
            <div>
                {msg?.message?.event_type != null && msg?.message?.event_type != "request_appointment" &&(
                    <div className={`text-gray-800 text-start`}>
                        <h1 className={`capitalize font-bold border-b py-1 px-2 rounded-t-md`}>{titleWithoutUnderscore(msg?.message?.event_type)}</h1>
                    </div>
                )}
                <div className='flex'>
                    {msg?.message?.event_type != null &&(
                        <div>
                            <SelectedMessageSection msg={msg}/>
                        </div>
                    )}
                    <div className="message-container line-clamp-1 text-left">
                        <ConvertStringToHtml msg={messageText} />
                    </div>
                    {media.length > 0 && (
                        <div className="ml-5 flex items-center">
                            <DocImg file={media[0]} />
                        </div>
                    )}
                </div>
            </div>
        );
    }
};

export default ReturnMessageToReply;